module.exports = __webpack_public_path__ + "media/partners/dragon_used_car_dealer-68656d10.png";